import React from 'react';
import { ToggleGroup, ToggleGroupItem } from './ui/toggle-group';

const UserIdFilter = ({ value, onChange }) => {
  return (
    <ToggleGroup 
      type="single" 
      value={value} 
      onValueChange={onChange}
      className="grid grid-cols-3 gap-1"
    >
      <ToggleGroupItem value="all" className="text-xs h-8">
        ВСЕ
      </ToggleGroupItem>
      <ToggleGroupItem value="even" className="text-xs h-8">
        ЧЕТНЫЕ
      </ToggleGroupItem>
      <ToggleGroupItem value="odd" className="text-xs h-8">
        НЕЧЕТНЫЕ
      </ToggleGroupItem>
    </ToggleGroup>
  );
};

export default UserIdFilter;
